type LeadTab = {
  label: string;
  count?: number;
  type: number;
};

type LeadTabNavProps = {
  tabs: LeadTab[];
  activeType: number;
  onChange: (type: number) => void;
};

function TabLabel({ label, count }: { label: string; count?: number }) {
  return (
    <span className="inline-flex items-center justify-center gap-1.5">
      {label}
      {count && count > 0 ? (
        <span className="rounded-full bg-purple-600 px-1.5 py-0.5 text-[10px] font-bold leading-none text-white">
          {count}
        </span>
      ) : null}
    </span>
  );
}

export default function LeadTabNav({
  tabs,
  activeType,
  onChange,
}: LeadTabNavProps) {
  return (
    <>
      <div className="sm:hidden">
        <label htmlFor="lead-tabs" className="sr-only">
          Select a tab
        </label>
        <select
          id="lead-tabs"
          name="lead-tabs"
          value={activeType}
          onChange={(event) => {
            onChange(Number(event.target.value));
          }}
          className="block w-full rounded-md border-gray-300 focus:border-purple-500 focus:ring-purple-500"
        >
          {tabs.map((tab) => (
            <option value={tab.type} key={`lead-tab-mobile-${tab.type}`}>
              {tab.label}
              {tab.count && tab.count > 0 ? ` (${tab.count})` : ''}
            </option>
          ))}
        </select>
      </div>

      <nav
        className="relative z-0 hidden divide-x divide-gray-200 overflow-hidden rounded-lg border border-gray-200 sm:flex"
        aria-label="Lead tabs"
      >
        {tabs.map((tab, index) => {
          const active = activeType === tab.type;

          return (
            <button
              key={`lead-tab-${tab.type}`}
              type="button"
              onClick={() => onChange(tab.type)}
              className={[
                'group relative min-w-0 flex-1 overflow-hidden px-3 py-3.5 text-center text-xs font-semibold transition-colors focus:z-10 focus:outline-none lg:px-4 lg:text-sm',
                active
                  ? 'bg-white text-gray-900'
                  : 'bg-gray-50 text-gray-500 hover:bg-gray-100 hover:text-gray-700',
                index === 0 ? 'rounded-l-lg' : '',
                index === tabs.length - 1 ? 'rounded-r-lg' : '',
              ].join(' ')}
            >
              <TabLabel label={tab.label} count={tab.count} />
              <span
                aria-hidden="true"
                className={`absolute inset-x-0 bottom-0 h-0.5 ${
                  active ? 'bg-purple-500' : 'bg-transparent'
                }`}
              />
            </button>
          );
        })}
      </nav>
    </>
  );
}

export type { LeadTab };
